var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.cardComponent,_vm._b({tag:"component",on:{"toggle":_vm.onToggle,"click":_vm.handlerAction,"close":function($event){return _vm.$emit('close')}}},'component',{ ..._vm.$attrs, ..._vm.$props, ..._vm.$emit },false),[_vm._l((_vm.$slots),function(_,name){return _vm._t(name,null,{"slot":name})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }